import { ApAuthenticationPage } from './ApAuthenticationPage';

import type { OrdResourceProps } from '@ragu-components/ord-resources';

export const apAuthenticationResource: OrdResourceProps = {
  key: 'ap_authentication',
  name: 'ap_authentication',
  list: <ApAuthenticationPage />,
  options: {},
};
